import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { getSession, incrementSessionViewCount } from '../utils/api.js'
import { Calendar, Clock, Image } from 'lucide-react'
import './Gallery.css'

export default function Gallery() {
  const { id } = useParams()
  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadSession()
  }, [id])

  async function loadSession() {
    try {
      const data = await getSession(id)
      setSession(data)
      incrementSessionViewCount(id).catch(err => console.error('Failed to record view:', err))
    } catch (err) {
      console.error('Failed to load gallery:', err)
      setError('Session not found or no longer available')
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="gallery-screen">
        <div className="loading">Loading gallery...</div>
      </div>
    )
  }

  if (error || !session) {
    return (
      <div className="gallery-screen">
        <div className="error-card">
          <h2>Gallery Not Found</h2>
          <p>{error || 'This session does not exist'}</p>
        </div>
      </div>
    )
  }

  const createdDate = new Date(session.created_at).toLocaleDateString()
  const createdTime = new Date(session.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })

  return (
    <div className="gallery-screen">
      <div className="gallery-header">
        <div className="header-content">
          <img src="/logo.png" alt="" className="gallery-logo" />
          <h1>{session.church_name}</h1>
          <p className="subtitle">Photo Gallery</p>
        </div>
      </div>

      <div className="gallery-content">
        <div className="session-info">
          <h2>{session.family_name}</h2>
          <div className="meta">
            <span><Calendar size={14} /> {createdDate}</span>
            <span><Clock size={14} /> {createdTime}</span>
            <span><Image size={14} /> {session.photos?.length || 0} photos</span>
          </div>
        </div>

        {session.photos?.length === 0 ? (
          <div className="empty-state">
            <p>No photos available yet.</p>
          </div>
        ) : (
          <div className="gallery-grid">
            {session.photos?.map((photo, index) => (
              <div key={photo.id} className="gallery-item">
                <img
                  src={photo.public_url}
                  alt={`Photo ${index + 1}`}
                  loading="lazy"
                  onClick={() => window.open(photo.public_url, '_blank')}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="gallery-footer">
        <p>{session.church_name}</p>
      </div>
    </div>
  )
}
